import React, { useState, useEffect, lazy, Suspense } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/football.webp";
const BlinkingText = lazy(() => import('../../BlinkingText'));
const RelatedLinks = lazy(() => import('../RelatedLinks'));
const MainCalculatorsList = lazy(() => import('./MainCalculators'));

const TITLE = "Décompte jusqu'aux Jeux Olympiques 2028 - Jours restants";
const DESCRIPTION = "Combien de jours restants jusqu'aux Jeux Olympiques 2028 à Los Angeles ? Le décompte jusqu'aux Jeux Olympiques vous fournit des informations précises sur la date de début de l'événement sportif mondial le plus important.";
const KEYWORDS = "Jeux Olympiques 2028, Los Angeles 2028, décompte Olympiques, date Jeux Olympiques 2028, combien de jours jusqu'aux Jeux Olympiques 2028, LA 2028";
const OG_URL = "https://do-calculate.com/articles-fr/olympics";

function OlympicsCountdown() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }
        return timeLeft;
    };

    const olympicsDate = new Date("2028-07-26T00:00:00");
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(olympicsDate));

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(olympicsDate));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);

    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className="p-3 mb-2 bg-success text-white">Décompte jusqu'aux Jeux Olympiques 2028</h1>
            <Suspense fallback={<div>Chargement...</div>}>
                <BlinkingText text="Décompte jusqu'aux Jeux Olympiques : les Jeux Olympiques 2028 devraient débuter le jeudi 26 juillet 2028 à Los Angeles, États-Unis." />
            </Suspense>
            <div className="row">
                <div id="timer" style={{ width: '100%', textAlign: 'center' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th className="bmi-header">Jours</th>
                                <th className="bmi-header">Heures</th>
                                <th className="bmi-header">Minutes</th>
                                <th className="bmi-header">Secondes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{timeLeft.days ?? 0}</td>
                                <td>{timeLeft.hours ?? 0}</td>
                                <td>{timeLeft.minutes ?? 0}</td>
                                <td>{timeLeft.seconds ?? 0}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className="p-3 mb-2 bg-success text-white">Informations sur les Jeux Olympiques 2028</h3>
                    <p>
                        Les Jeux Olympiques sont un événement sportif mondial qui se tient tous les quatre ans, où des athlètes du monde entier s'affrontent dans de nombreuses disciplines sportives. Les Jeux Olympiques 2028 se dérouleront à Los Angeles, aux États-Unis, et l'on s'attend à des compétitions passionnantes dans de nombreux sports. Le monde entier attend cet événement avec enthousiasme.
                    </p>
                    <p>
                        Cette édition des Jeux Olympiques sera mémorable car les Jeux reviendront aux États-Unis 32 ans après leur dernière organisation là-bas à Atlanta en 1996. La France, récente hôte des Jeux Olympiques de Paris 2024, sera représentée par de nombreux athlètes talentueux.
                    </p>
                    <hr />
                    <Suspense fallback={<div>Chargement...</div>}>
                        <RelatedLinks />
                    </Suspense>
                </div>
                <div className="col-sm-4 col-md-4">
                    <Suspense fallback={<div>Chargement...</div>}>
                        <MainCalculatorsList />
                    </Suspense>
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className="p-3 mb-2 bg-success text-white">Les Jeux Olympiques</h3>
                    <p>
                        Les Jeux Olympiques sont le plus grand événement sportif international, regroupant des milliers d'athlètes de plus de 200 pays participants. Les Jeux se déclinent en deux formats : les Jeux Olympiques d'été et les Jeux Olympiques d'hiver, tous deux organisés tous les quatre ans.
                    </p>
                    <div>
                        <br />
                        <img
                            src={imageUrl}
                            alt="Décompte jusqu'aux Jeux Olympiques 2028"
                            width="800"
                            height="450"
                            style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                            loading="lazy"
                        />
                        <br />
                    </div>
                </div>
            </div>
            <MobileUnderCalAds />
        </div>
    );
}

export default OlympicsCountdown;
